export default {
  namespaced: true,
  state: () => ({
    items: [],
  }),
};
